import React, { useEffect, useState } from 'react';
import CloseImage from '../../assets/ic_close.png';
import { FormControl, IconButton, Input, InputAdornment, InputLabel, Snackbar, TextField, Typography } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import api from '../api';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import MuiAlert from '@material-ui/lab/Alert';
import CustomTextField from '../components/customTextField';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function EditUser(props) {
    const [dataRole, setDataRole] = useState([])
    const [role, setRole] = useState(null)
    const [username, setUsername] = useState("")
    const [showPass, setShowPass] = useState(false)
    const [email, setEmail] = useState("")
    const [nama, setNama] = useState("")
    const [password, setPassword] = useState("")
    const [id, setID] = useState("")
    const [messageAlert, setMessageAlert] = useState("")
    const [statusAlert, setStatusAlert] = useState("")
    const [openAlert, setOpenAlert] = useState(false);
    const [errorName, setErrorName] = React.useState(false);
    const [errorUsername, setErrorUsername] = React.useState(false);
    const [errorEmail, setErrorEmail] = React.useState(false);
    const [errorRole, setErrorRole] = React.useState(false);
    const [texterrorName, setTextErrorName] = React.useState(null);
    const [texterrorUsername, setTextErrorUsername] = React.useState(null);
    const [texterrorEmail, setTextErrorEmail] = React.useState(null);
    const [textErrorRole, setTextErrorRole] = React.useState(null);

    const forceUpdate = React.useReducer(bool => !bool)[1];

    useEffect(() => {
        getDetailUser()
    }, [])

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false)
    }

    const getDetailUser = () => {
        api.create().getUserDetail(props.detail[5]).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    setID(data.id)
                    setNama(data.name)
                    setUsername(data.username)
                    setEmail(data.email)
                    getDataRole(data.role)
                    forceUpdate()

                }
            }
        })
    }

    const getDataRole = (name) => {
        api.create().getListRole().then(response => {
            if (response.data) {
                if (response.data.status === true) {
                    let dataRole = []
                    response.data.data.map((item) => {
                        if (item.is_active === true) {
                            dataRole.push({
                                value: item.name,
                                id: item.id
                            })
                        }
                    })
                    let idx = dataRole.findIndex((val) => val.value === name)
                    setDataRole(dataRole)
                    setRole(dataRole[idx])
                    forceUpdate()
                }
            }
        })
    }

    const doSubmit = () => {
        if (username === "") {
            setErrorUsername(true)
            setTextErrorUsername("Username wajib diisi")
        } else if (email === "") {
            setErrorEmail(true)
            setTextErrorEmail("Email wajib diisi")
        } else if (nama === "") {
            setErrorName(true)
            setTextErrorName("Fullname wajib diisi")
        } else if (role === null) {
            setErrorRole(true)
            setTextErrorRole("Role wajib diisi")
        } else {
            let payload = {}
            if (password === "") {
                payload = {
                    "account_id": id,
                    "email": email,
                    "fullname": nama,
                    "username": username,
                    "role_id": role.id
                }
            } else {
                payload = {
                    "account_id": id,
                    "email": email,
                    "fullname": nama,
                    "username": username,
                    "password": password,
                    "role_id": role.id
                }
            }
            api.create().updateUser(payload).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        props.onClose()
                        props.getData()
                    } else {
                        if (response.data.data) {
                            if (response.data.data.email) {
                                setOpenAlert(true)
                                setMessageAlert(response.data.data.email)
                                setStatusAlert("warning")
                            } else if (response.data.data.password) {
                                setOpenAlert(true)
                                setMessageAlert(response.data.data.password)
                                setStatusAlert("warning")
                            } else if (response.data.data.username) {
                                setOpenAlert(true)
                                setMessageAlert(response.data.data.username)
                                setStatusAlert("warning")
                            }
                        }
                    }
                }
            })
        }

    }

    return (
        <div className="App app-popup-show">
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            <div className="popup-content-middle background-white" style={{ borderRadius: 8 }}>
                <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Edit User</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>

                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: 20 }}>
                    <div className="column-1">
                        <CustomTextField
                            label="ID"
                            variant="filled"
                            disabled={true}
                            value={id}
                        />
                        <div style={{ marginTop: 15 }}>
                            <CustomTextField
                                required={true}
                                label={"Email"}
                                value={email}
                                error={errorEmail}
                                helperText={texterrorEmail}
                                onChange={(val) => {
                                    setEmail(val)
                                    setErrorEmail(false)
                                    setTextErrorEmail(null)
                                }}
                            />
                        </div>
                        <Autocomplete
                            options={dataRole}
                            getOptionLabel={(option) => option.value}
                            disableClearable
                            name='role'
                            id="role"
                            onChange={(event, newInputValue) => {
                                setRole(newInputValue)
                                setErrorRole(false)
                                setTextErrorRole(null)
                                forceUpdate()
                            }}
                            style={{ marginTop: 15 }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                    InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                    label="Role"
                                    required={true}
                                    error={errorRole}
                                    helperText={textErrorRole}
                                />
                            }
                            value={role}
                        />
                    </div>

                    <div className="column-2">
                        <div style={{marginTop: 8}}>
                            <CustomTextField
                                required={true}
                                value={username}
                                label={"Username"}
                                error={errorUsername}
                                helperText={texterrorUsername}
                                onChange={(val) => {
                                    setUsername(val)
                                    setErrorUsername(false)
                                    setTextErrorUsername(null)
                                }}
                            />
                        </div>
                        <div style={{ marginTop: 16 }}>
                            <CustomTextField
                                required={true}
                                value={nama}
                                label={"Full Name"}
                                error={errorName}
                                helperText={texterrorName}
                                onChange={(val) => {
                                    setNama(val)
                                    setErrorName(false)
                                    setTextErrorName(null)
                                }}
                            />
                        </div>
                        <FormControl style={{ width: '100%', marginTop: 11 }}>
                            <InputLabel htmlFor="standard-adornment-password" style={{ fontSize: 14 }}>Password</InputLabel>
                            <Input
                                id="standard-adornment-password"
                                type={showPass ? 'text' : 'password'}
                                value={password}
                                onChange={(e) => {
                                    setPassword(e.target.value)
                                    forceUpdate()
                                }}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={() => setShowPass(!showPass)}
                                        >
                                            {showPass ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                    </div>
                </div>
                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                    <div className="column-1" style={{ alignSelf: 'center' }}>
                    </div>
                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <div
                            onClick={() => props.onClose()}
                            style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                        </div>
                        <div
                            onClick={(e) => doSubmit(e)}
                            style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}